import gql from 'graphql-tag'

export default gql`
  mutation destroyFiscalYear($rid: Int!, $entityType: String!) {
    destroyFiscalYear(input: { rid: $rid, entityType: $entityType }) {
      fiscalYear {
        year
      }
    }
  }
`
